import { ReactNode } from "react";
import { ChartRoutes } from "../../components/Graphics/General/General/ChartRoutes";
import { MapRoutes } from "../../components/Graphics/General/General/MapRoutes";
import { NumbersDayDocuments } from "../../components/Graphics/General/NumbersDay/Documents";
import { NumbersDayFinishedDocuments } from "../../components/Graphics/General/NumbersDay/FinishedDocuments";
import { NumbersDayDeliveredDocumentsSlaDealine } from "../../components/Graphics/General/NumbersDay/DeliveredDocumentsSlaDealine";
import { NumbersDayFinishedRoutes } from "../../components/Graphics/General/NumbersDay/FinishedRoutes";
import { NumbersDayReturns } from "../../components/Graphics/General/NumbersDay/Returns";
import { NumbersDayRoutes } from "../../components/Graphics/General/NumbersDay/Routes";
import { ChartOccurrencesDeliveries } from "../../components/Graphics/General/Occurrences/ChartOccurrencesDeliveries";
import { ChartDocumentsSlaDelayed } from "../../components/Graphics/General/Sla/ChartDocumentsSlaDelayed";
import { ChartOccurrencesReturn } from "../../components/Graphics/General/Occurrences/ChartOccurrencesReturn";
import { ChartArrivals } from "../../components/Graphics/General/DeparturesArrivals/ChartArrivals";
import { ChartDepartures } from "../../components/Graphics/General/DeparturesArrivals/ChartDepartures";
import { ChartReturns } from "../../components/Graphics/General/Returns/ChartReturns";
import { ChartDeliveries } from "../../components/Graphics/General/General/ChartDeliveries";
import { ChartOccurrencesDeliveriesTop } from "../../components/Graphics/General/Occurrences/ChartOccurrencesDeliveriesTop";
import { ChartOccurrencesNotDeliveriesTop } from "../../components/Graphics/General/Occurrences/ChartOccurrencesNotDeliveriesTop";
import { ChartOccurrencesNotDeliveries } from "../../components/Graphics/General/Occurrences/ChartOccurrencesNotDeliveries";
import { ChartPunctualGeneral } from "../../components/Graphics/General/Eta/ChartPunctualGeneral";
import { ChartPunctualDelayed } from "../../components/Graphics/General/Eta/ChartPunctualDelayed";
import { ChartPunctualSuperDelayed } from "../../components/Graphics/General/Eta/ChartPunctualSuperDelayed";
import { NumbersDayCollectsDocuments } from "../../components/Graphics/General/NumbersDay/CollectsDocuments";
import { ChartGeneralCollectsDocuments } from "../../components/Graphics/General/Collects/chartGeneralCollectsDocuments";
import { ChartRegionCollectsDocuments } from "../../components/Graphics/General/Collects/chartRegionCollectsDocuments";
import { ChartCarrierCollectsDocuments } from "../../components/Graphics/General/Collects/chartCarrierCollectsDocuments";
import { ChartTimeOnClientCollects } from "../../components/Graphics/General/Times/chartTimeOnClientCollects";
import { ChartTimeOnClientDeliveries } from "../../components/Graphics/General/Times/chartTimeOnClientDeliveries";
import { ChartRegionAvg } from "../../components/Graphics/General/Delays/chartRegionAvg";
import { ChartRegionCount } from "../../components/Graphics/General/Delays/chartRegionCount";
import { ChartShipperAvg } from "../../components/Graphics/General/Delays/chartShipperAvg";
import { ChartShipperCount } from "../../components/Graphics/General/Delays/chartShipperCount";
import { ChartDetailsNotStartedCollectsDocuments } from "../../components/Graphics/General/Collects/chartDetailsNotStartedCollectsDocuments";
import { ChartGeneralNotStartedCollectsDocuments } from "../../components/Graphics/General/Collects/chartGeneralNotStartedCollectsDocuments";
import { NumbersDayCollectsDocumentsNotStarted } from "../../components/Graphics/General/NumbersDay/CollectsDocumentsNotStarted";
import { ChartStatusDocuments } from '../../components/Graphics/General/General/ChartDocuments';
import { RoutesBeginDelays } from '../../components/Graphics/General/General/ChartRoutesBeginDelays';
import { RoutesFinishedOnInterval } from '../../components/Graphics/General/General/ChartRoutesFinishedOnInterval';
import { RoutesAverageStayOnInterval } from '../../components/Graphics/General/General/ChartRoutesAverageStayOnInterval';

import { api } from '../../services/api';
import { FiPieChart } from "react-icons/fi";
import { IoBarChartOutline } from "react-icons/io5";
import { TbMap2 } from "react-icons/tb";
import { TiSortNumerically } from "react-icons/ti";
import { VscTable } from "react-icons/vsc";
import { Graphics } from "../../contexts/Dashboard/DashboardContext";
import { ChartSchedulingCollectsDocuments } from "../../components/Graphics/General/Collects/chartSchedulingCollectsDocuments";
import { ChartAdoptionRateShipper } from "../../components/Graphics/General/Adoption/ChartAdoptionRateShipper";
import { ChartAdoptionRateRegion } from "../../components/Graphics/General/Adoption/ChartAdoptionRateRegion";
import { ChartAdoptionRateCourier } from "../../components/Graphics/General/Adoption/ChartAdoptionRateCourier";
import { ChartDocumentsDeliveredPerSla } from "../../components/Graphics/General/Sla/ChartDocumentsDeliveredPerSla";
import { ChartDocumentsDeliveredPerSlaDetailed } from "../../components/Graphics/General/Sla/ChartDocumentsDeliveredPerSlaDetailed";
import { ChartClientCollectsDocuments } from "../../components/Graphics/General/Collects/chartClientCollectsDocuments";

export const defaultProps = {
  cols: { xxl: 120, xl: 100, lg: 80, md: 60, sm: 40, xs: 20, xxs: 10 },
  rowHeight: 10,
  margin: [20, 20],
  containerPadding: [0, 10],
  autoSize: true,
};

interface Screen  {
  screen:  string[];
 }

export async function dataComponent(id: string): Promise<[Graphics[], string[]]> {
  let graphics: Graphics[];
  let graphicsInScreen: string[] = [''];
  const dataGraphics: Graphics[] = [];
  const promises: Promise<unknown>[] = [];
  const url = `/graphics/${id}`;
  promises.push(
    api.get(url)
      .then((graphicsData: {data: [Graphics[], Screen]}) => {
        graphics = graphicsData.data[0];
        graphicsInScreen = graphicsData.data[1].screen;
        graphics.forEach((graphic: Graphics) => {
          let auxComponent: ReactNode;
          let iconChart: {icon: ReactNode, title: string};

          switch (graphic.id) {
            case "chartRoutes":
              auxComponent = <ChartRoutes />
              iconChart =  {icon: <FiPieChart />, title: 'Gráfico de pizza'};
              break;

            case "mapRoutes":
              auxComponent = <MapRoutes />
              iconChart = {icon: <TbMap2 />, title: 'mapa'};
              break;

            case "chartDeliveries":
              auxComponent = <ChartDeliveries />
              iconChart = {icon: <FiPieChart />, title: 'Gráfico de pizza'};
              break;

            case "numbersDayRoutes":
              auxComponent = <NumbersDayRoutes />
              iconChart = {icon: <TiSortNumerically />, title: 'Gráfico numérico'};
              break;

            case "numbersDayFinishedRoutes":
              auxComponent = <NumbersDayFinishedRoutes />
              iconChart = {icon: <TiSortNumerically />, title: 'Gráfico numérico'};
              break;

            case "numbersDayDocuments":
              auxComponent = <NumbersDayDocuments />
              iconChart = {icon: <TiSortNumerically />, title: 'Gráfico numérico'};
              break;

            case "numbersDayFinishedDocuments":
              auxComponent = <NumbersDayFinishedDocuments />
              iconChart = {icon: <TiSortNumerically />, title: 'Gráfico numérico'};
              break;

            case "numbersDayDeliveredDocumentsSlaDealine":
              auxComponent = <NumbersDayDeliveredDocumentsSlaDealine />
              iconChart = {icon: <TiSortNumerically />, title: 'Gráfico numérico'};
              break;

            case "numbersDayReturns":
              auxComponent = <NumbersDayReturns />
              iconChart = {icon: <TiSortNumerically />, title: 'Gráfico numérico'};
              break;

            case "chartOccurrencesDeliveries":
              auxComponent = <ChartOccurrencesDeliveries />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartOccurrencesDeliveriesTop":
              auxComponent = <ChartOccurrencesDeliveriesTop />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartOccurrencesNotDeliveries":
              auxComponent = <ChartOccurrencesNotDeliveries />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartOccurrencesNotDeliveriesTop":
              auxComponent = <ChartOccurrencesNotDeliveriesTop />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartOccurrencesReturn":
              auxComponent = <ChartOccurrencesReturn />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartDepartures":
              auxComponent = <ChartDepartures />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartArrivals":
              auxComponent = <ChartArrivals />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartReturns":
              auxComponent = <ChartReturns />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartPunctualGeneral":
              auxComponent = <ChartPunctualGeneral />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartPunctualDelayed":
              auxComponent = <ChartPunctualDelayed />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartPunctualSuperDelayed":
              auxComponent = <ChartPunctualSuperDelayed />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartDocumentsSlaDelayed":
              auxComponent = <ChartDocumentsSlaDelayed />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartRegionAvg":
              auxComponent = <ChartRegionAvg/>
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartRegionCount":
              auxComponent = <ChartRegionCount />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartShipperAvg":
              auxComponent = <ChartShipperAvg/>
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartShipperCount":
              auxComponent = <ChartShipperCount />
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "numbersDayCollectsDocuments":
              auxComponent = <NumbersDayCollectsDocuments/>
              iconChart = {icon: <TiSortNumerically />, title: 'Gráfico numérico'};
              break;

            case "chartGeneralCollectsDocuments":
              auxComponent = <ChartGeneralCollectsDocuments/>
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartRegionCollectsDocuments":
              auxComponent = <ChartRegionCollectsDocuments/>
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartCarrierCollectsDocuments":
              auxComponent = <ChartCarrierCollectsDocuments/>
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartClientCollectsDocuments":
              auxComponent = <ChartClientCollectsDocuments/>
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartTimeOnClientCollects":
              auxComponent = <ChartTimeOnClientCollects/>
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartTimeOnClientDeliveries":
              auxComponent = <ChartTimeOnClientDeliveries/>
              iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
              break;

            case "chartDetailsNotStartedCollectsDocuments":
              auxComponent = <ChartDetailsNotStartedCollectsDocuments/>
              iconChart =  {icon: <VscTable />, title: 'Tabela'};
              break;

            case "chartGeneralNotStartedCollectsDocuments":
              auxComponent = <ChartGeneralNotStartedCollectsDocuments/>
              iconChart =  {icon: <FiPieChart />, title: 'Gráfico de pizza'};
              break;

            case "numbersDayCollectsDocumentsNotStarted":
              auxComponent = <NumbersDayCollectsDocumentsNotStarted/>
              iconChart = {icon: <TiSortNumerically />, title: 'Gráfico numérico'};
              break;

            case "chartStatusDocuments":
            auxComponent = <ChartStatusDocuments/>
            iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
            break;

          case "chartSchedulingCollectsDocuments":
            auxComponent = <ChartSchedulingCollectsDocuments />;
            iconChart = { icon: <FiPieChart />, title: "Gráfico de pizza" };
            break;

          case "chartAdoptionRateShipper":
            auxComponent = <ChartAdoptionRateShipper />;
            iconChart = { icon: <IoBarChartOutline />, title: "Gráfico de barras" };
            break;

          case "chartAdoptionRateRegion":
            auxComponent = <ChartAdoptionRateRegion />;
            iconChart = { icon: <IoBarChartOutline />, title: "Gráfico de barras" };
            break;

          case "chartAdoptionRateCourier":
            auxComponent = <ChartAdoptionRateCourier />;
            iconChart = { icon: <IoBarChartOutline />, title: "Gráfico de barras" };
            break;

          case "chartDocumentsDeliveredPerSla":
            auxComponent = <ChartDocumentsDeliveredPerSla />;
            iconChart = {icon: <TiSortNumerically />, title: 'Gráfico numérico'};
            break;
  
          case "chartDocumentsDeliveredPerSlaDetailed":
            auxComponent = <ChartDocumentsDeliveredPerSlaDetailed />;
            iconChart = { icon: <IoBarChartOutline />, title: "Gráfico de barras" };
            break;

          case "chartRoutesBeginDelays":
            auxComponent = <RoutesBeginDelays type={"chart"}/>
            iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
            break;

          case "tableRoutesBeginDelays":
            auxComponent = <RoutesBeginDelays type={"table"}/>
            iconChart = {icon: <VscTable />, title: 'Tabela'};
            break;

          case "chartRoutesFinishedOnInterval":
            auxComponent = <RoutesFinishedOnInterval type={"chart"}/>
            iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
            break;

          case "tableRoutesFinishedOnInterval":
            auxComponent = <RoutesFinishedOnInterval type={"table"}/>
            iconChart = {icon: <VscTable />, title: 'Tabela'};
            break;

          case "chartRoutesAverageStayOnInterval":
            auxComponent = <RoutesAverageStayOnInterval type={"chart"}/>
            iconChart = {icon: <IoBarChartOutline />, title: 'Gráfico de barras'};
            break;

          case "tableRoutesAverageStayOnInterval":
            auxComponent = <RoutesAverageStayOnInterval type={"table"}/>
            iconChart = {icon: <VscTable />, title: 'Tabela'};
            break;

          default:
            iconChart = {
              icon: <IoBarChartOutline />,
              title: "Gráfico de barras",
            };
            break;
        }
        dataGraphics.push({
          ...graphic,
          component: auxComponent,
          iconChart: iconChart,
        });
      });
    })
  );
  await Promise.all(promises);
  return [dataGraphics, graphicsInScreen];
}
